<div class="card email-tester-card">
  <div class="email-tester-header">
    <div>
      <h2>Email template tester</h2>
      <p>
        Preview a backend template with sample values, then send it to a test
        inbox.
      </p>
    </div>
    <span class="admin-badge">Superadmin only</span>
  </div>

  <div class="loading-state" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <form
    *ngIf="!isLoading && templates.length"
    [formGroup]="emailForm"
    (ngSubmit)="sendTestEmail()"
    class="email-tester-grid"
  >
    <section class="template-controls">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Email template</mat-label>
        <mat-select
          formControlName="templateId"
          (selectionChange)="selectTemplate($event.value)"
        >
          <mat-option
            *ngFor="let template of templates"
            [value]="template.templateId"
          >
            {{ template.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="template-summary" *ngIf="selectedTemplate">
        <strong>{{ selectedTemplate.subject }}</strong>
        <p>{{ selectedTemplate.description }}</p>
      </div>

      <div formGroupName="templateData" class="template-fields">
        <mat-form-field
          appearance="outline"
          class="w-100"
          *ngFor="let field of selectedTemplate?.fields"
        >
          <mat-label>{{ field.label }}</mat-label>
          <textarea
            *ngIf="field.isMultiline"
            matInput
            rows="6"
            [formControlName]="field.key"
          ></textarea>
          <input
            *ngIf="!field.isMultiline"
            matInput
            [formControlName]="field.key"
          />
          <mat-error>This value is required.</mat-error>
        </mat-form-field>
      </div>

      <button
        type="button"
        mat-stroked-button
        color="primary"
        class="preview-button"
        [disabled]="isPreviewLoading"
        (click)="refreshPreview()"
      >
        <mat-spinner *ngIf="isPreviewLoading" diameter="18"></mat-spinner>
        <mat-icon *ngIf="!isPreviewLoading">refresh</mat-icon>
        Refresh preview
      </button>

      <div class="send-panel">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Send test email to</mat-label>
          <input
            matInput
            type="email"
            autocomplete="email"
            formControlName="recipientEmail"
            placeholder="tester@example.com"
          />
          <mat-error
            *ngIf="emailForm.get('recipientEmail').hasError('required')"
          >
            A recipient email is required.
          </mat-error>
          <mat-error *ngIf="emailForm.get('recipientEmail').hasError('email')">
            Enter a valid email address.
          </mat-error>
        </mat-form-field>

        <button
          type="submit"
          mat-flat-button
          color="primary"
          class="send-button"
          [disabled]="isSending"
        >
          <span class="button-content">
            <span class="button-icon-slot">
              <mat-spinner *ngIf="isSending" diameter="18"></mat-spinner>
              <mat-icon *ngIf="!isSending">send</mat-icon>
            </span>
            <span>Send test email</span>
            <span class="button-icon-slot" aria-hidden="true"></span>
          </span>
        </button>
      </div>
    </section>

    <section class="preview-panel">
      <div class="preview-heading">
        <div>
          <span>EMAIL PREVIEW</span>
          <strong>{{ previewSubject || selectedTemplate?.subject }}</strong>
        </div>
        <mat-spinner *ngIf="isPreviewLoading" diameter="22"></mat-spinner>
      </div>

      <iframe
        *ngIf="previewHtml && !isPreviewLoading"
        [srcdoc]="previewHtml"
        sandbox=""
        title="Rendered email template preview"
      ></iframe>

      <div
        class="preview-placeholder"
        *ngIf="!previewHtml && !isPreviewLoading"
      >
        <mat-icon>email</mat-icon>
        <p>The rendered email will appear here.</p>
      </div>
    </section>
  </form>

  <div class="empty-state" *ngIf="!isLoading && !templates.length">
    No email templates are available.
  </div>
</div>
